import BookingIndigoSvg from "@/src/assets/icons/icon-booking-indigo.svg";
import BookingSvg from "@/src/assets/icons/icon-booking-white.svg";
import CorporateManagementSvg from "@/src/assets/icons/icon-building-setting-white.svg";
import ContractIndigoSvg from "@/src/assets/icons/icon-document-copy-indigo.svg";
import ContractSvg from "@/src/assets/icons/icon-document-copy-white.svg";
import ClientManagementSvg from "@/src/assets/icons/icon-document-setting-white.svg";
import ExclamationSvg from "@/src/assets/icons/icon-exclamation.svg";
import FaqIndigoSvg from "@/src/assets/icons/icon-faq-indigo.svg";
import FaqSvg from "@/src/assets/icons/icon-faq.svg";
import FileBoxIndigoSvg from "@/src/assets/icons/icon-file-box-indigo.svg";
import FileBoxSvg from "@/src/assets/icons/icon-file-box-white.svg";
import HomeIndigoSvg from "@/src/assets/icons/icon-home-indigo.svg";
import HomeSvg from "@/src/assets/icons/icon-home.svg";
import InquiryIndigoSvg from "@/src/assets/icons/icon-inquiry-indigo.svg";
import InquirySvg from "@/src/assets/icons/icon-inquiry.svg";
import LoadingContainerIndigoSvg from "@/src/assets/icons/icon-loading-container-indigo.svg";
import LoadingContainerSvg from "@/src/assets/icons/icon-loading-container.svg";
import NoticeIndigoSvg from "@/src/assets/icons/icon-notice-indigo.svg";
import NoticeSvg from "@/src/assets/icons/icon-notice.svg";
import OpenWhiteSvg from "@/src/assets/icons/icon-open-white.svg";
import ShipmentIndigoSvg from "@/src/assets/icons/icon-ship-indigo.svg";
import ShipmentSvg from "@/src/assets/icons/icon-ship-white.svg";
import EXPORTER_PRIVATE_PATH from "@/src/routes/exporter/path";
import PUBLIC_PATH from "@/src/routes/public/path";

const EXPORTER_OPERATION_NAV_MENU = [
  {
    iconSrc: HomeSvg,
    selectedIconSrc: HomeIndigoSvg,
    labelKey: "sideNav:home",
    destination: EXPORTER_PRIVATE_PATH.HOME,
  },
  {
    iconSrc: ContractSvg,
    selectedIconSrc: ContractIndigoSvg,
    labelKey: "sideNav:contract",
    destination: EXPORTER_PRIVATE_PATH.CONTRACT,
  },
  {
    iconSrc: BookingSvg,
    selectedIconSrc: BookingIndigoSvg,
    labelKey: "sideNav:booking",
    destination: EXPORTER_PRIVATE_PATH.BOOKING,
  },
  {
    iconSrc: LoadingContainerSvg,
    selectedIconSrc: LoadingContainerIndigoSvg,
    labelKey: "sideNav:loading",
    destination: EXPORTER_PRIVATE_PATH.LOADING,
  },
  {
    iconSrc: ShipmentSvg,
    selectedIconSrc: ShipmentIndigoSvg,
    labelKey: "sideNav:shipment",
    destination: EXPORTER_PRIVATE_PATH.SHIPMENT,
  },
  {
    iconSrc: FileBoxSvg,
    selectedIconSrc: FileBoxIndigoSvg,
    labelKey: "sideNav:fileBox",
    destination: EXPORTER_PRIVATE_PATH.FILE_BOX,
  },
];

const EXPORTER_CUSTOMER_SERVICE_MENU = [
  {
    iconSrc: NoticeSvg,
    selectedIconSrc: NoticeIndigoSvg,
    labelKey: "sideNav:notice",
    destination: EXPORTER_PRIVATE_PATH.NOTICE,
  },
  {
    iconSrc: InquirySvg,
    selectedIconSrc: InquiryIndigoSvg,
    labelKey: "sideNav:inquiry",
    destination: EXPORTER_PRIVATE_PATH.INQUIRY,
  },
  {
    iconSrc: FaqSvg,
    selectedIconSrc: FaqIndigoSvg,
    labelKey: "sideNav:faq",
    destination: EXPORTER_PRIVATE_PATH.FAQ,
  },
];

const EXPORTER_MANAGEMENT_NAV_MENU = [
  {
    iconSrc: CorporateManagementSvg,
    isOpen: false,
    labelKey: "sideNav:workspaceSettings",
    closeHeight: 72,
    fullHeight: 288,
    includePath: [
      "company-information",
      "member-management",
      "client-management",
      "subscription-management",
    ],
    children: [
      {
        labelKey: "sideNav:companyInformation",
        destination: EXPORTER_PRIVATE_PATH.COMPANY_INFORMATION,
      },
      {
        labelKey: "sideNav:members",
        destination: EXPORTER_PRIVATE_PATH.MEMBER_MANAGEMENT,
      },
      {
        labelKey: "sideNav:clients",
        destination: EXPORTER_PRIVATE_PATH.CLIENT_MANAGEMENT,
      },
      {
        labelKey: "sideNav:subscription",
        destination: EXPORTER_PRIVATE_PATH.SUBSCRIPTION_MANAGEMENT,
      },
    ],
  },
  {
    iconSrc: ClientManagementSvg,
    isOpen: false,
    labelKey: "sideNav:tradeSettings",
    closeHeight: 48,
    fullHeight: 120,
    includePath: ["item-management", "factory-management"],
    children: [
      {
        labelKey: "sideNav:items",
        destination: EXPORTER_PRIVATE_PATH.ITEM_MANAGEMENT,
      },
      {
        labelKey: "sideNav:factory",
        destination: EXPORTER_PRIVATE_PATH.FACTORY_MANAGEMENT,
      },
    ],
  },
];

const EXPORTER_BETA_FEEDBACK_NAV_MENU = [
  {
    iconSrc: ExclamationSvg,
    selectedIconSrc: ExclamationSvg,
    labelKey: "sideNav:bugReport",
    destination: "https://walla.my/v/eTkrMjsEdFclisTHyju7",
    isBlank: true,
    rightIconSrc: OpenWhiteSvg,
  },
];

const EXPORTER_TERMS_POLICY_NAV_MENU = [
  {
    destination: `${PUBLIC_PATH.TERMS}?selectTab=termsOfUse`,
    isBlank: true,
    labelKey: "sideNav:termsOfUse",
  },
  {
    destination: `${PUBLIC_PATH.TERMS}?selectTab=privacyPolicy`,
    isBlank: true,
    labelKey: "sideNav:privacyPolicy",
  },
];

export {
  EXPORTER_OPERATION_NAV_MENU,
  EXPORTER_CUSTOMER_SERVICE_MENU,
  EXPORTER_MANAGEMENT_NAV_MENU,
  EXPORTER_BETA_FEEDBACK_NAV_MENU,
  EXPORTER_TERMS_POLICY_NAV_MENU,
};
